import { FC } from 'react';
import { faSquareCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { i18nTB } from 'utils/shared/utils';

type TripBuilderClientHotelsCta2Props = {
  onDownloadPdf?: () => void;
  disabled?: boolean;
};

const TripBuilderClientHotelsCta2: FC<TripBuilderClientHotelsCta2Props> = ({
  onDownloadPdf,
  disabled,
}) => {
  const { t, i18n } = useTranslation(undefined, { i18n: i18nTB });
  const isRtl = i18n.language === 'he';

  return (
    <section className="tb2-hotels-cta" dir={isRtl ? 'rtl' : 'ltr'}>
      <h2 className="tb2-hotels-cta-title">
        <span>{t('trip_builder.hotels_cta_title_line1')}</span>
        <span>{t('trip_builder.hotels_cta_title_line2')}</span>
      </h2>
      <button
        type="button"
        className="tb2-hotels-cta-submit"
        onClick={onDownloadPdf}
        disabled={disabled}
      >
        <FontAwesomeIcon icon={faSquareCheck} aria-hidden="true" />
        {t('trip_builder.send_route')}
      </button>
    </section>
  );
};

export default TripBuilderClientHotelsCta2;
